module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toggle-switch",
    attrs: {
      "disabled": _vm.isEnabled,
      "data-ts-color": ""
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.label && _vm.label.length > 0),
      expression: "label&&label.length>0"
    }],
    staticClass: "ts-label",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.myvalue),
      expression: "myvalue"
    }, {
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "id": _vm.id,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.myvalue) ? _vm._i(_vm.myvalue, null) > -1 : (_vm.myvalue)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.myvalue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.myvalue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.myvalue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.myvalue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "ts-helper",
    attrs: {
      "for": _vm.id
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b2140f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/toggleswitch.vue
// module id = 552
// module chunks = 23